// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1H27R","text":"styles_text__1rzBa","whiteIcon":"styles_whiteIcon__2-4FD"};